export const stateMeasurementReport = Object.freeze({
  id: 7,
  name: 'Informe de Medición del Estado',
});

export const gradeReport = Object.freeze({
  id: 8,
  name: 'Informe de Notas',
});

export const vocationalInterestInventory = Object.freeze({
  id: 9,
  name: 'Inventario de intereses vocacionales',
});

const data = Object.freeze({
  StateMeasurementReport: stateMeasurementReport.id,
  GradeReport: gradeReport.id,
  VocationalInterestInventory: vocationalInterestInventory.id,
});

export default data;
